export class EditTranslation {
    constructor() {
        this.inputsWrapperElement = $("#inputs");
        this.originalTextElement = document.getElementById("translationText");
        const wrapper = $("#translation-edit-wrapper");
        if (wrapper.length === 0) {
            return;
        }
        this.textElements = this.originalTextElement.querySelectorAll(this.classes);
        if (this.multiple) {
            wrapper.addClass("multiple");
        }
        this.createInputs();
    }
    get classes() {
        return `.${this.originalTextElement.dataset["textClass"].replace(/\s+/g, ".")}`;
    }
    get multiple() {
        return this.textElements.length > 1;
    }
    createInputs() {
        const idPrefix = this.originalTextElement.dataset["textIdPrefix"];
        for (const textElement of this.textElements) {
            if (!$(textElement).attr("id").startsWith(idPrefix)) {
                throw new Error(`El elemento ${$(textElement)} no tiene el id correcto`);
            }
            this.inputsWrapperElement.append(this.createInput(textElement));
        }
    }
    createInput(textElement) {
        const inputName = this.inputsWrapperElement.data("inputName");
        const input = $(`<textarea name="${inputName}[]" class="translation col-xs-12">${$(textElement).text()}</textarea>`);
        if (this.multiple) {
            input.addClass("hidden");
            $(textElement).on("click", () => {
                this.onTextClicked(input);
            });
        }
        return input;
    }
    onTextClicked(input) {
        const show = input.hasClass("hidden");
        $(".translation").addClass("hidden");
        if (show) {
            input.removeClass("hidden");
        }
    }
}
